import {
  AdminRoleManagement,
  UserRoleManagement,
} from 'pages/roles/components';

import { useCanAccess } from 'hooks/useCanAccess';
import { Unauthorized } from 'components/unauthorized';
import { TokenExpired } from 'components/tokenExpired';

export const RoleManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('roles');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminRoleManagement />
  ) : canAccess ? (
    <UserRoleManagement />
  ) : (
    <Unauthorized />
  );
};
